export default {"src":"/_next/static/media/direct-high-speed.02ca7d5d.svg","height":437,"width":526,"blurWidth":0,"blurHeight":0};